// mqttConfig.ts
function getMqttPrefix(): string {
  const hostname = window.location.hostname;

  // Map dealer portal hostname to its corresponding MQTT prefix
  // dealer-beta.myarcticspa.com → beta-as
  // dealer-beta.mycoldtub.com   → beta-ct
  // dealer.myarcticspa.com      → arcticspa
  // dealer.mycoldtub.com        → coldtub
  if (hostname.startsWith('dealer-beta.')) {
    if (hostname.includes('mycoldtub')) return 'beta-ct';
    if (hostname.includes('myarcticspa')) return 'beta-as';
  }
  if (hostname.startsWith('dealer.')) {
    if (hostname.includes('mycoldtub')) return 'coldtub';
    if (hostname.includes('myarcticspa')) return 'arcticspa';
  }

  // Fallback for local development
  return process.env.REACT_APP_MQTT_PREFIX ?? 'beta-as';
}

export const MQTT_PREFIX = getMqttPrefix();

const mqttConfig = {
    broker: process.env.REACT_APP_MQTT_BROKER,
    port: parseInt(process.env.REACT_APP_MQTT_PORT || '1883', 10),
  };

  export default mqttConfig;
